var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "6fc3a6d96b34a29fc05bd3060f29d73c7f4a070a"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["launchpad@printdeal"] = {
  id: "6fc3a6d96b34a29fc05bd3060f29d73c7f4a070a"
};